import axios from "axios";
import config from "../../config";
import { headers_get } from "../../main_components/tokens/get_headers_user";

const BASE_URL = `https://zv901ycwfj.execute-api.us-east-1.amazonaws.com`;

const BASE_URL_SUPPLIER = `https://s7ppqwu1ig.execute-api.us-east-1.amazonaws.com`;


const request = async (method, endpoint, data = null, params = null, baseUrl = BASE_URL) => {
    const url = `${baseUrl}${endpoint}`;
    try {
        const headers = await headers_get(true);
        return await axios({ method, url, data, headers, params });
    } catch (error) {
        console.error(`Error in ${method.toUpperCase()} ${url}:`, error?.response?.data || error.message);
        throw error;
    }
};


export const purchase_order_concepts_get = async () => {
    return request('get', '/od/concepts');
};

export const supplier_invoice_details_get = async (id_supplier) => {
    return request('get', `/od/supplier-invoices/${id_supplier}/details`, null, null, BASE_URL_SUPPLIER);
};


export const purchase_order_details_get = async (id_order) => {
    return request('get', `/od/purchase-orders/${id_order}/details`,);
};

export const supplier_orders_get = async (params) => {
    return request('get', `/od/purchase-orders/supplier-orders`, null, params,);
};



export const purchase_order_pdf_get = async (id_order) => {
    return request('get', `/od/purchase-orders/${id_order}/pdf`,);
};



export const purchase_order_code_get = async () => {
    return request('get', `/od/purchase-orders/order-number`,);
};


export const income_rules_users_get = async () => {
    return request('get', '/od/expense-income-rules/users');
};

export const purchase_order_notifications_post = async (id_order,data) => {
    return request('post', `/od/purchase-orders/${id_order}/notifications`, data);
};

export const purchase_order_post = async (data) => {
    return request('post', '/od/purchase-orders', data);
};

export const purchase_order_put = async (id_order, data) => {
    return request('put', `/od/purchase-orders/${id_order}`, data);
};

export const purchase_order_concept_put = async (id_order, id_detail, data) => {
    return request('put', `/od/purchase-orders/${id_order}/details/${id_detail}`, data);
};

export const purchase_order_concept_post = async (id_order, data) => {
    return request('post', `/od/purchase-orders/${id_order}/details`, data);
};
export const purchase_order_concept_delete = async (id_order, id_detail) => {
    return request('delete', `/od/purchase-orders/${id_order}/details/${id_detail}`);
};


export const purchase_order_delete = async (id_order) => {
    return request('delete', `/od/purchase-orders/${id_order}`);
};





export const staus_purchase_order_post = async (id, data, params) => {
    return request('post', `/od/purchase-orders/${id}/relationships`, data, params);
};




export const relationships_purchase_order_post = async (id, params) => {
    return request('post', `/od/purchase-orders/relationships/${id}`, {}, params);
};

